// 自定义页面头部配置 https://qm-base.qmniu.com/h5-ui/#/q-navigation#api
export const navConfig = {
    fullScreen: true,
    menuConfig: {
        right: [
            {
                icon: '&#xe65f;',
                type: 'share',
            }
        ],
    },
    // beginBufferNumber: 1,
    // endBufferRatio: 1, // 两个都为1，表示不显示过渡效果（透明度）
    styleConfig: {
        default: {
            text: {
                color: '#fff',
                opacity: 1,
            },
            title: {
                color: '#fff',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'white',
        },
        fixed: {
            text: {
                color: '#fff',
                opacity: 1,
            },
            title: {
                color: '#fff',
                opacity: 1,
            },
            bg: {
                background: '#FF3C4D',
            },
            statusBar: 'white',
        },
    },
};

// 分享配置
export const shareConfig = {
    title: '2025，我的七猫年度报告',
    desc: '点亮年度勋章，觉醒阅读形象',
    imageUrl: 'https://cdn-front-global.wtzw.com/manual-upload/freereader/activity/share-icon.png',
    link: 'https://app-share.wtzw.com/h5/activity/freereader2025AnnualReport/index?full_screen=3',
};
// 分享类型列表
export const shareTypeList = ['save', 'weixin', 'friend', 'qq', 'qzone'];
